import IsoDropdown from '../UI/Dropdown/Dropdown';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { Button, Col, Row } from 'reactstrap';
import Keys from '../../../_Translations/generated/group-request.en.t.json.keys';
import { SelectRef } from '../Form/Select/Select';
import { range } from 'lodash-es';
import { ReactSelectOption } from '../../../Models/ReactSelectOption';
import React, { useState, JSX } from 'react';
import {
  MAX_NUMBER_OF_ADULTS,
  MAX_NUMBER_OF_CHILDREN,
  MIN_NUMBER_OF_SUPPORTED_PARTICIPANTS,
  TravelersPickerProps
} from './externals';
import useTranslation from '../../Hooks/useTranslation';
import fallback from '../../../_Translations/generated/group-request.en.t.json';
import { SelectInstance as ReactSelectInstance } from 'react-select';

const TravelersPicker = (props: TravelersPickerProps): JSX.Element => {
  const { t } = useTranslation('group-request', fallback, Keys);
  const {
    numberOfAdults,
    numberOfChildren,
    id,
    tempNumberOfAdults,
    setTempNumberOfAdults,
    portalRef,
    tempNumberOfChildren,
    setTempNumberOfChildren,
    setNotEnoughParticipantsError,
    setNumberOfAdults,
    setNumberOfChildren
  } = props;

  const [dropdownOpen, setDropdownOpen] = useState(false);
  let selectAdultRef: ReactSelectInstance<ReactSelectOption> | null = null;
  let selectChildRef: ReactSelectInstance<ReactSelectOption> | null = null;

  function getTitle(): string {
    return `${numberOfAdults + numberOfChildren}`;
  }

  function getSelectOption(value: number): ReactSelectOption {
    return { value: String(value), label: String(value) };
  }

  function handleClick(): void {
    if (tempNumberOfAdults + tempNumberOfChildren < MIN_NUMBER_OF_SUPPORTED_PARTICIPANTS) {
      setNotEnoughParticipantsError(true);
      return;
    }
    setNumberOfAdults(tempNumberOfAdults);
    setNumberOfChildren(tempNumberOfChildren);
    setDropdownOpen(false);
    setNotEnoughParticipantsError(false);
  }

  const isPaxDropDownOpen = (): boolean => {
    let isOpen = false;
    if (selectAdultRef && selectAdultRef.props) {
      isOpen = selectAdultRef.props.menuIsOpen;
    }

    if (!isOpen && selectChildRef && selectChildRef.props) {
      isOpen = selectChildRef.props.menuIsOpen;
    }

    return isOpen;
  };

  const toggleTravelersDropdown = (): void => {
    if (!isPaxDropDownOpen()) {
      setDropdownOpen(!dropdownOpen);
    }
  };

  return (
    <IsoDropdown
      isOpen={dropdownOpen}
      onDropdownToggle={toggleTravelersDropdown}
      icon={faUser}
      title={getTitle()}
      id={id}
    >
      <div className="p-2">
        <Row>
          <Col>
            <div className="p-0">{t(Keys.adult, { count: 0 })}</div>
            <div className="small p-0 mb-1">{t(Keys.adultAgeRange)}</div>
            <SelectRef
              options={range(1, MAX_NUMBER_OF_ADULTS + 1).map(val => {
                return getSelectOption(val);
              })}
              selectedOption={getSelectOption(tempNumberOfAdults)}
              onChange={(val: ReactSelectOption): void =>
                setTempNumberOfAdults(Number((val as ReactSelectOption).value))
              }
              getLabel={(option): string => (option ? option.label : '')}
              getValue={(option): string => (option ? option.value : '')}
              menuPortalTarget={portalRef.current || undefined}
              ref={(ref): void => {
                selectAdultRef = ref;
              }}
            />
          </Col>
          <Col>
            <div className="p-0">{t(Keys.child)}</div>
            <div className="small p-0 mb-1">{t(Keys.childAgeRange)}</div>
            <SelectRef
              options={range(0, MAX_NUMBER_OF_CHILDREN + 1).map(val => {
                return getSelectOption(val);
              })}
              selectedOption={getSelectOption(tempNumberOfChildren)}
              onChange={(val: ReactSelectOption): void =>
                setTempNumberOfChildren(Number((val as ReactSelectOption).value))
              }
              getLabel={(option): string => (option ? option.label : '')}
              getValue={(option): string => (option ? option.value : '')}
              menuPortalTarget={portalRef.current || undefined}
              ref={(ref): void => {
                selectChildRef = ref;
              }}
            />
          </Col>
        </Row>
        <Row className="pt-2">
          <Col>
            <Button color="secondary" block onClick={handleClick}>
              {t(Keys.button.set)}
            </Button>
          </Col>
        </Row>
      </div>
    </IsoDropdown>
  );
};

export default TravelersPicker;
